import * as React from "react";
import { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";

import Button from "components/Button";
import { INSTANT_OFFER_URL } from "constants/index";

export function composeShareValuationUrl(valuationId: number, userId: number) {
  const queryString = [
    "utm_source=royaltyexchange",
    "utm_medium=referral",
    "utm_campaign=know_your_worth",
    "utm_content=analysis_page",
    `ref_acct=${userId}`,
    `ref_val=${valuationId}`,
  ].join("%26");

  return `${INSTANT_OFFER_URL}?${queryString}`;
}

const useStyles = makeStyles(theme => ({
  container: {
    width: "100%",
    padding: theme.spacing(2),
    display: "flex",
    gap: theme.spacing(1),
  },
  input: {
    flexGrow: 1,
    fontSize: "1rem",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
  },
}));

interface Props {
  valuationId: number;
  userId: number;
}

export const ShareUrlButton: React.FC<Props> = ({ valuationId, userId }) => {
  const classes = useStyles();
  const [hasClicked, setHasClicked] = useState(false);

  const copyLink = async () => {
    const url = composeShareValuationUrl(valuationId, userId);
    await navigator.clipboard.writeText(url);

    setHasClicked(true);
    setTimeout(() => {
      setHasClicked(false);
    }, 3000);
  };

  return (
    <Box className={classes.container}>
      <input
        className={classes.input}
        type="text"
        value={composeShareValuationUrl(valuationId, userId)}
        readOnly
      />
      <Button
        variant="contained"
        customColor="green"
        onClick={copyLink}
        style={{ whiteSpace: "nowrap" }}
      >
        {hasClicked ? "Link Copied" : "Copy Link"}
      </Button>
    </Box>
  );
};
